<template>
  <VueperSlides
    autoplay
    class="no-shadow reviews store_reviews"
    :visible-slides="2"
    :gap="2"
    slide-multiple
    fixed-height="270px"
    :dragging-distance="50"
    :breakpoints="breakpoints"
    :touchable="true"
    duration="10000"
  >
    <VueperSlide
      v-for="(review, index) in reviewsList"
      :key="'review_'+index"
    >
      <template #content>
        <div class="slide_content">
          <div class="row m-0">
            <div class="review_image text-left col">
              <img
                class="align-middle"
                alt="Emoji Feliz"
                :src="review.icon"
                height="128"
                width="128"
              >
            </div>

            <div class="col review_title text-right">
              <span class="subtitle"> {{ review.subtitle }}</span>
              <br>
              <span class="date"> {{ review.date }}</span>
            </div>
          </div>
          <div class="row m-0">
            <div class="review_content">
              <p class="title mb-1">
                {{ review.title }}
              </p>
              <p class="m-0">
                {{ review.content }}
              </p>
            </div>
          </div>
        </div>
      </template>
    </vueperslide>
  </vueperslides>
</template>
<script>
import { VueperSlide, VueperSlides } from 'vueperslides';
import '@/assets/css/custom-vueper-slide.css';
import TimeAgo from 'javascript-time-ago';

import en from 'javascript-time-ago/locale/en';
import es from 'javascript-time-ago/locale/es';
import it from 'javascript-time-ago/locale/it';
import pt from 'javascript-time-ago/locale/pt';

TimeAgo.addLocale(en);
TimeAgo.addLocale(es);
TimeAgo.addLocale(it);
TimeAgo.addLocale(pt);

export default {
  name: 'StoreReviewsCarousel',
  components: {
    VueperSlides,
    VueperSlide,
  },
  props: {
    reviews: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      reviewsList: [],
      breakpoints:
          {
            768: {
              visibleSlides: 1,
              slideMultiple: 1,
              arrows: true,
              bulletsOutside: true,
              touchable: true,
            },
            992: {
              visibleSlides: 2,
              slideMultiple: 2,
              arrows: true,
              bulletsOutside: false,
              touchable: true,
            },
            1400: {
              visibleSlides: 1,
              slideMultiple: 1,
              arrows: true,
              bulletsOutside: false,
              touchable: true,
            },
            4000: {
              visibleSlides: 2,
              slideMultiple: 2,
              arrows: true,
              bulletsOutside: false,
              touchable: true,
            },

          },
    };
  },
  created() {
    this.createReviewsList(this.reviews);
  },

  methods: {
    createReviewsList(data) {
      let count = 1;
      const { lang } = this.$store.state.main;

      data.forEach((review) => {
        let title = '';
        let subtitle = '';
        let date = '';
        let content = '';
        let icon = '';

        subtitle = `${review.booking.user.full_name.split(' ')[0]} ${review.booking.user.full_name.split(' ')[1].substring(0, 1)}.`;

        content = review.comment;

        if (review.booking_ok) {
          title = `¡${this.$t('lang.reviews.all_ok')}!`;
          icon = require(`../../assets/img/icons/review-${count}.png`);
          count++;
          if (count === 10) count = 1;
        } else {
          title = this.$t('lang.reviews.any_problem');
          icon = require('../../assets/img/icons/emoji_neutral.png');
        }
        const timeAgo = new TimeAgo(lang);
        const reviewDate = new Date((`${review.updated_at}`).replace(/-/g, '/')); // Replace function needed to work on Safari
        date = timeAgo.format(reviewDate);

        this.reviewsList.push({
          title, subtitle, date, content, icon,
        });
      });
    },
  },
};
</script>

<style scoped>
</style>
